import type { LocaleMessageBundle } from '../../types'

export const statusMessages: LocaleMessageBundle = {
  vi: {
    'common.status.active': 'Hoạt động',
    'common.status.inactive': 'Tạm ngưng',
    'common.restore-success': 'Khôi phục thành công.',
    'common.actions.toggleStatus': 'Đổi trạng thái',
    'common.actions.toggleToActive': 'Bật trạng thái hoạt động',
    'common.actions.toggleToInactive': 'Tạm ngưng',
  },
  en: {
    'common.status.active': 'Active',
    'common.status.inactive': 'Inactive',
    'common.restore-success': 'Restored successfully.',
    'common.actions.toggleStatus': 'Toggle status',
    'common.actions.toggleToActive': 'Set as active',
    'common.actions.toggleToInactive': 'Set as inactive',
  },
}
